export const GET_STATUS_REQUEST = "GET_STATUS_REQUEST";
export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";
export const GET_STATUS_FAILURE = "GET_STATUS_FAILURE";

export const GET_GST_NUMBER_VERIFY_REQUEST = "GET_GST_NUMBER_VERIFY_REQUEST";
export const GET_GST_NUMBER_VERIFY_SUCCESS = "GET_GST_NUMBER_VERIFY_SUCCESS";
export const GET_GST_NUMBER_VERIFY_FAILURE = "GET_GST_NUMBER_VERIFY_FAILURE";
